import styled from "@emotion/styled";

export const ModalWrapper = styled.div`
  background-color: #fff;
  min-width: 640px;
`;
